<template>
  <v-container
    fluid
    fill-height
    class="pt-0"
  >
    <v-row>
      <v-col>
        <account-credits />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <doc-list-card
          :card-title="'Drafts'"
          :doc-list="dashboardDocs"
          :loading="documentsLoading"
          :num-docs="documents.length"
          :is-individual="isIndividual"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DocListCard from '@/components/DocListCard'
import AccountCredits from '@/components/AccountCredits'

export default {
  name: 'Dashboard',
  components: { DocListCard, AccountCredits },
  data: () => ({
    accountUsersLoading: true,
    clientUsersLoading: true
  }),
  beforeCreate() {
    this.dispatchActions(['checkAuth', 'get_appUser', 'get_documents'])

    this.mapStates([
      'user',
      'appUser',
      'appUserBinding',
      'appUserLoading',
      'documents',
      'documentsLoading',
      'claimsLoading'
    ])
    this.mapGetters(['isIndividual', 'usersById', 'dashboardDocs'])
  },
  async created() {
    await this.appUserBinding

    if (this.isIndividual) {
      this.clientUsersLoading = false
      this.accountUsersLoading = false
    } else {
      this.$store.dispatch('get_clientUsers').then((value) => {
        this.clientUsersLoading = false
      })
      this.$store.dispatch('get_accountUsers').then((value) => {
        /* TODO BETA workaround for firestore bug where it fires onSnapshot twice with different data
           check if this still occurs after next firestore release */
        setTimeout(() => {
          this.accountUsersLoading = false
        }, 500)
      })
    }
  }
}
</script>

<style></style>

<style lang="scss">
$baseMinWidth: 95+95;
$baseMaxWidth: 95+152;
$baseHeight: 95;
$mr: 4;
$mb: 4;

@for $c from 1 through 2 {
  $minWidth: $c * ($baseMinWidth) + ($c - 1) * $mr;
  $maxWidth: $c * ($baseMaxWidth) + ($c - 1) * $mr;
  @for $r from 1 through 2 {
    $height: $r * ($baseHeight) + ($r - 1) * $mr;
    .ol-tile-#{$c}-#{$r} {
      min-width: #{$minWidth}px;
      max-width: #{$maxWidth}px;
      height: #{$height}px;
    }
  }
}
</style>
